import { useMemo, useSyncExternalStore } from 'react';
import { getDetectedClientPreferences } from '../lib/clientSessionMetadata';
import type { SupportedCurrency } from '../utils/currency';

const subscribe = () => () => undefined;
const getServerSnapshot = (): SupportedCurrency => 'USD';

export function useDetectedCurrency(): SupportedCurrency {
    const getSnapshot = useMemo(() => {
        let currency: SupportedCurrency | null = null;
        return () => {
            currency ??= getDetectedClientPreferences().preferredCurrency;
            return currency;
        };
    }, []);

    // React uses this same USD snapshot for static HTML and initial hydration.
    // Browser detection takes over afterward; native uses getSnapshot directly.
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
